import CutwiseAPIClient, { METHOD_GET } from '@/common/network/CutwiseAPIClient';
import QueryResult from '@/common/network/QueryResult';
import { SpectrumProductModel } from '@/spectrum/entities/SpectrumProduct';

export const PATH_MODELS_SPECTRUM = 'api/models/spectrum';
export const PATH_MODELS_DEADZONES = 'api/models/deadzones';

export type SpectrumModelsType = 'spectrum' | 'deadzones';

export default class SpectrumAPI {
  fetchModels(
    type: SpectrumModelsType,
    ids?: number[],
    abortSignal?: AbortSignal,
  ): Promise<QueryResult<SpectrumProductModel[]>> {
    const path = type === 'deadzones' ? PATH_MODELS_DEADZONES : PATH_MODELS_SPECTRUM;

    const qb = CutwiseAPIClient.createQueryBuilder()
      .method(METHOD_GET)
      .path(path)
      .addQueryStringParam('id', ids)
      .suppressErrorNotifications();

    if (abortSignal) {
      qb.abortSignal(abortSignal);
    }

    return CutwiseAPIClient.sendQuery(qb.getQuery());
  }
}
